import { EboObjectTimePeriod } from '../base-classes/ebo-object-time-period';
import { Employee } from '../employee/employee';
import { EProcess } from '../process/e-process';
import { TimeOffType, TimeOffTypeMapping } from '../schedule/time-off/time-off.enum';
import { CalendarEventType } from './calendar-event-type.enum';

export class CalendarEvent extends EboObjectTimePeriod {
  requestId: string;
  request: EProcess;
  allDay: boolean;
  employeeID: string;
  employee?: Employee;
  override name: string;
  eventType: CalendarEventType;
  timeOffType?: TimeOffType;
  description?: string;
  location?: string;

  constructor(jsonData?: Partial<CalendarEvent>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.request) this.request = new EProcess(jsonData.request);
      if (jsonData.employee) this.employee = new Employee(jsonData.employee);
    }
    //if (jsonData.endTime) console.log(jsonData.endTime, this.endTime);
    this.eventType ??= CalendarEventType.Unknown;
    this.timeOffType ??= TimeOffType.None;
  }
  toShortString(format: string = null) {
    let dayPart: string;
    if (this.allDay) {
      if (this.startTime.isSame(this.endTime, 'day')) dayPart = `${this.startTime.format('M/D/YY')}`;
      else dayPart = `${this.startTime.format('M/D/YY')} - ${this.endTime.format('M/D/YY')}`;
    } else {
      dayPart = `${this.startTime.format('M/D/YY')}${
        this.endTime?.format('M/D/YY') ? ' -' + this.endTime.format('M/D/YY') : ''
      }`;
    }
    return format === 'eTask'
      ? `${dayPart}: ${TimeOffTypeMapping[this.timeOffType]}`
      : `${dayPart}: ${TimeOffTypeMapping[this.timeOffType]} - ${this.name}`;
  }
}
